/*
 * Copyright (C) 2018 BarD Software s.r.o
 *
 * Author: Dmitry Barashev (dbarashev@bardsoftware.com)
 */

import Plausible from "plausible-tracker";

const plausible = Plausible({
    domain: 'ganttproject.biz',
    trackLocalhost: true,
    hashMode: true
});

export function installGoogleAnalytics() {
    const cookie = document.cookie;
    if (cookie) {
        cookie.split(';').forEach(function(keyValue) {
            if (keyValue.trim() === 'ga_opt_out=true') {
                window['ga-disable-UA-1173427-8'] = true;
            }
            return;
        });
    }
    window.dataLayer = window.dataLayer || [];
    window.ga = function(){window.dataLayer.push(arguments);}
    window.ga('js', new Date());
    window.ga('config', 'G-8EPLLZPDLC', {
        //@ts-ignore:
        send_page_view: false
    });
}

export function gaSendPageview(page?: string) {
    if (window['ga-disable-UA-1173427-8']) {
        return;
    }
    window.ga('event', 'page_view', {
        page_title: page,
        page_location: page
    });
    //plausible.trackPageview();
}

type EventData = { readonly [propName: string]: string | number | boolean };
export function gaSendEvent(event: string, params: EventData = {}) {
    if (window['ga-disable-UA-1173427-8']) {
        return;
    }
    window.ga('event', event, params);
    //plausible.trackEvent(event, {props: params})
}

export function gaSendExperiment(experimentName: string, experimentCase: number) {
    if (window['ga-disable-UA-1173427-8']) {
        return;
    }
    gaSendEvent('experiment', {
        "experiment_name": experimentName,
        "experiment_case": experimentCase
    });
}
function createItems(product: string, platform: string, quantity: number) {
    return [{
        item_id: `${product} ${platform}`,
        item_name: `${product} ${platform}`,
        quantity: quantity,
        price: 1.0
    }];
}

const PRODUCT = 'GanttProject 3.3';
export function gaSendCheckoutView(platform: string) {
    if (window['ga-disable-UA-1173427-8']) {
        return;
    }
    window.ga('event', 'view_item', {
        currency: 'USD',
        value: 0,
        items: createItems(PRODUCT, platform, 0)
    });
}

export function gaSendCheckoutItem(platform: string, quantity: number) {
    if (window['ga-disable-UA-1173427-8']) {
        return;
    }
    window.ga('event', 'add_to_cart', {
        currency: 'USD',
        value: quantity,
        items: createItems(PRODUCT, platform, quantity)
    });
}

export function gaSendCheckoutStarted(platform: string, quantity: number, netValue: number) {
    if (window['ga-disable-UA-1173427-8']) {
        return;
    }

    window.ga('event', 'begin_checkout', {
        currency: 'USD',
        value: netValue,
        items: createItems(PRODUCT, platform, quantity)
    });
    // plausible.trackEvent("begin_checkout", {
    //     props: {
    //         platform: platform,
    //         quantity: quantity,
    //         value: netValue
    //     }
    // })
}

export function gaSendCheckoutCompleted(platform: string, quantity: number, netValue: number, txnId: string, experimentCase: number) {
    if (window['ga-disable-UA-1173427-8']) {
        return;
    }

    window.ga('event', 'checkout_completed');
    window.ga('event', 'purchase', {
        currency: 'USD',
        value: netValue,
        transaction_id: txnId,
        experimentCase: experimentCase,
        items: createItems(PRODUCT, platform, quantity)
    });
    // plausible.trackEvent("purchase", {
    //     props: {
    //         purchase: true,
    //         platform: platform,
    //         quantity: quantity,
    //         value: netValue,
    //         experimentCase: experimentCase
    //     }
    // })
}